import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withKeys as _withKeys, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex items-center relative" }
const _hoisted_2 = { class: "relative flex flex-col h-full z-10" }
const _hoisted_3 = ["onClick", "onKeydown"]
const _hoisted_4 = { class: "min-w-[32px] min-h-[32px] rounded-full bg-gray-300 items-center justify-center flex" }
const _hoisted_5 = { class: "flex flex-col w-max max-w-[400px]" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "ml-2" }
const _hoisted_8 = { class: "flex items-center gap-x-1" }
const _hoisted_9 = { class: "text-gray-500 overflow-hidden truncate whitespace-nowrap max-w-[350px]" }

import { ref, computed, PropType, nextTick } from "vue"
import { ChevronDownIcon, InboxIcon, HomeIcon, OfficeBuildingIcon } from "@heroicons/vue/outline"
import GmailIcon from "@/components/icons/GmailIcon.vue"
import SendgridIcon from "@/components/icons/SendgridIcon.vue"
import OutlookIcon from "@/components/icons/OutlookIcon.vue"
import { Sender } from "@/shared/models/sender"
import { getInitials, internationalPhoneFormat } from "@/shared/utils/helpers"


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactDropdown',
  props: {
    type: {
        type: String,
        default: "sms",
        validator: (value: string) => ["sms", "email"].includes(value),
    },
    selectedSender: {
        type: Object as PropType<Sender>,
        default: () => ({} as Sender),
    },
    senders: {
        type: Array as PropType<Sender[]>,
        default: () => [],
    },
    dropdownClass: {
        type: String,
        default: "",
    },
    senderClass: {
        type: String,
        default: "",
    },
    isInSidebar: {
        type: Boolean,
        default: false,
    },
},
  emits: ["close", "select", "update:selectedSender"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const menu = ref()
const appendToRef = ref(null)
const menuVisible = ref(false)

const localSelectedSender = computed({
    get: () => props.selectedSender,
    set: (value: Sender) => {
        emit("update:selectedSender", value)
    },
})
const isMessageType = computed(() => props.type === "sms")
const overlayStyle = computed(() => [
    isMessageType.value ? "!-left-56" : "!-left-80",
    "ring-1 ring-black ring-opacity-5 shadow-lg rounded-md bg-white z-10 w-max !top-[8px] right-0",
])

const dropdownStyle = computed(() => [props.isInSidebar ? "fixed right-[110px]" : "relative", "z-10 right-0 "])

const integrationIconFunctionsMap = {
    gmail: GmailIcon,
    sendgrid: SendgridIcon,
    outlook: OutlookIcon,
    twilio: InboxIcon,
    custom: InboxIcon,
}

function getSenderData() {
    return isMessageType.value
        ? internationalPhoneFormat(localSelectedSender.value?.phone?.number || "")
        : localSelectedSender.value?.email
}

function onOverlayHide() {
    menuVisible.value = false
}

function getContactInformation(contact: Sender) {
    return isMessageType.value ? internationalPhoneFormat(contact?.phone?.number || "") : contact?.email
}

function getIntegrationIcon(contact: Sender) {
    if (!contact.integrationName) {
        return InboxIcon
    }
    return integrationIconFunctionsMap[contact.integrationName]
}

function selectContact(contact: Sender) {
    localSelectedSender.value = contact
    emit("update:selectedSender", contact)
    menuVisible.value = false
    menu.value.hide()
}

function openOverlayPanel(event: MouseEvent) {
    if (!props.senders.length) {
        return
    }
    nextTick(() => {
        menuVisible.value = !menuVisible.value
        menuVisible.value ? menu.value.show(event) : menu.value.hide()
    })
}

return (_ctx: any,_cache: any) => {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([
                'flex justify-center items-center py-1 px-2.5 rounded-full bg-gray-100 h-6 w-full cursor-pointer',
                __props.dropdownClass,
            ]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (openOverlayPanel($event)))
    }, [
      (!isMessageType.value)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(getIntegrationIcon(localSelectedSender.value)), {
            key: 0,
            class: "h-6 w-6"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("p", {
        class: _normalizeClass(['text-sm font-medium text-gray-800 w-fit ml-1 flex gap-x-1.5 items-center', __props.senderClass])
      }, [
        _createTextVNode(_toDisplayString(localSelectedSender.value?.name) + " ", 1),
        (localSelectedSender.value?.type === 'personal')
          ? (_openBlock(), _createBlock(_unref(HomeIcon), {
              key: 0,
              class: "w-4 h-4"
            }))
          : (localSelectedSender.value?.type === 'agency')
            ? (_openBlock(), _createBlock(_unref(OfficeBuildingIcon), {
                key: 1,
                class: "w-4 h-4"
              }))
            : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(getSenderData()), 1)
      ], 2),
      _createVNode(_unref(ChevronDownIcon), { class: "h-3 w-3 m-0 inline-block ml-1" })
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(dropdownStyle.value),
      ref_key: "appendToRef",
      ref: appendToRef
    }, [
      _createVNode(_component_OverlayPanel, {
        ref_key: "menu",
        ref: menu,
        appendTo: appendToRef.value,
        onHide: onOverlayHide,
        class: _normalizeClass(overlayStyle.value)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.senders, (contact) => {
              return (_openBlock(), _createElementBlock("div", {
                key: contact?.name,
                tabindex: "0",
                class: "z-10 rounded-md flex items-center gap-x-2 outline-primary-color-500 hover:bg-gray-50 px-4 py-3 cursor-pointer",
                onClick: ($event: any) => (selectContact(contact)),
                onKeydown: _withKeys(($event: any) => (selectContact(contact)), ["enter"])
              }, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(getInitials)(contact?.name || "")), 1),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (!isMessageType.value)
                      ? (_openBlock(), _createBlock(_resolveDynamicComponent(getIntegrationIcon(contact)), {
                          key: 0,
                          class: "h-6 w-6"
                        }))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(contact?.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    (contact?.type === 'personal')
                      ? (_openBlock(), _createBlock(_unref(HomeIcon), {
                          key: 0,
                          class: "w-4 h-4 text-gray-400"
                        }))
                      : (contact?.type === 'agency')
                        ? (_openBlock(), _createBlock(_unref(OfficeBuildingIcon), {
                            key: 1,
                            class: "w-4 h-4 text-gray-400"
                          }))
                        : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_9, " (" + _toDisplayString(getContactInformation(contact)) + ") ", 1)
                  ])
                ])
              ], 40, _hoisted_3))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["appendTo", "class"])
    ], 2)
  ]))
}
}

})